import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Segment
} from 'semantic-ui-react';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class NominaCargosView extends Component {

  constructor (props) {
    super(props);

    this.CargoService = this.props.feathers.service('/api/cargos');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(cargo) => ({
            id: cargo.id,
            header: `${cargo.nombre}`,
            description: `Orden ${cargo.orden}`
          })}
          service={this.CargoService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 8],
              ['!Orden', 'orden', 'input', 4]
            ],
            service: this.CargoService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    NominaCargosView.mapStateToProps,
    NominaCargosView.mapDispatchToProps
  )(NominaCargosView)
);



// WEBPACK FOOTER //
// ./client/components/pages/misc/CargosView.js